import React from "react";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";

const TextField = ({
  id,
  label,
  required = true,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  infoContent,
  infoLabel,
  error = "",
  hint = "",
  hintTone = "",
  className = "",
  readOnly = false,
  autoComplete,
  maxLength,
}) => (
  <div className={`signup-form__field${className ? ` ${className}` : ""}`}>
    {label ? (
      <FieldLabel
        htmlFor={id}
        required={required}
        infoContent={infoContent}
        infoLabel={infoLabel}
      >
        {label}
      </FieldLabel>
    ) : null}
    <input
      id={id}
      className={`signup-form__input${error ? " is-invalid" : ""}${readOnly ? " is-readonly" : ""}${hintTone === "success" ? " is-success" : ""}`}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={readOnly ? undefined : onChange}
      onBlur={readOnly ? undefined : onBlur}
      required={required}
      readOnly={readOnly}
      tabIndex={readOnly ? -1 : undefined}
      autoComplete={autoComplete}
      maxLength={maxLength}
      aria-invalid={Boolean(error)}
      aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
    />
    <FieldError id={`${id}-error`}>{error}</FieldError>
    {!error && hint ? (
      <p
        id={`${id}-hint`}
        className={`signup-form__hint${hintTone ? ` signup-form__hint--${hintTone}` : ""}`}
      >
        {hint}
      </p>
    ) : null}
  </div>
);

export default TextField;
